const specialCurrencyMap: Record<string, string> = {
  SAR: '\uFAA5',
  AED: '\uFAA4',
  OMR: '\uFAA6',
};

export const formatCurrencyForDisplay = (originalCurrency: string) => {
  const symbol = specialCurrencyMap[originalCurrency];

  if (symbol) {
    return {
      displayCurrency: symbol,
      // `notranslate` keeps Google Translate from re-parenting the symbol glyph
      // out of the `.currency-font` span. The symbol chars (U+FAA4-FAA6) live in
      // the CJK Compatibility block, so Translate treats them as translatable
      // text and, once moved, they render as raw CJK ideographs instead of the
      // custom currency glyph.
      currencyClassName: 'currency-font notranslate',
      currencyFontFamily: 'currencyFont',
    };
  }

  return {
    displayCurrency: originalCurrency,
    currencyClassName: '',
    currencyFontFamily: '',
  };
};
